import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'
import { LoginInterface } from '../../Interfaces/LoginInterface'

const store = CreateGenericSlice<
  LoginInterface,
  SliceCaseReducers<LoginInterface>
>({
  name: 'loginUser',
  initialState: {},
  reducers: {
    loginUser: (state, { payload }) => {
      state.userData = payload?.userData
      state.token = payload?.token
    },
  },
})

export const { loginUser } = store.actions

export default store.reducer
